module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"metaSkill":"Meta-ferdighet","partOf":"Del av"},"en":{"metaSkill":"Meta-skill","partOf":"Part of"}}')
  delete Component.options._Ctor
}
